import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

export function NewTagDialog({ open, onOpenChange, onCreated }) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/tags", { name });
      onCreated(data);
      setName("");
      onOpenChange(false);
      toast.success(t("tagDialog.tagCreatedSuccess"));
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-sm" data-testid="new-tag-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{t("tagDialog.newTagTitle")}</DialogTitle>
          <DialogDescription>{t("tagDialog.newTagDescription")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="tag-name">{t("tagDialog.tagNameLabel")}</Label>
            <Input id="tag-name" data-testid="new-tag-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder={t("tagDialog.tagNamePlaceholder")} className="rounded-none" autoFocus />
          </div>
          <Button type="submit" disabled={loading} data-testid="new-tag-submit-button" className="w-full rounded-none">
            {loading ? t("common.creating") : t("tagDialog.createButton")}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
